<template>
<div>

<div class="contenttopbar grid px-3 mt-1">
<div class="col-10 md:col-9">
<h3 class="text-primary mb-3 mt-3 font-medium">{{$store.state.languages.lang_phrases.firma_belgeleri}}</h3>
</div>

<div class="col-2 md:col-3">

<div class="flex align-items-center justify-content-end" v-if="!is_supplier && !is_planner">
<div class="hide_on_mobile"><Button type="button" :class="'p-button-primary p-button-outlined p-button-sm mt-2'" :label="$store.state.languages.lang_phrases.yeni_ekle" icon="pi pi-plus" @click="addNew" /></div>
<div class="show_on_mobile"><Button type="button" :class="'p-button-primary p-button-outlined p-button-sm mt-2'" icon="pi pi-plus" @click="addNew" /></div>
</div>
</div>
</div>





<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<div class="content_card" v-if="!loading">
<div class="grid mt-4">

<template v-if="addnew">
<div class="col-12  md:col-6">


<div class="grid">
<div class="col-10">
<div class="p-float-label mb-5 mt-0">
<Dropdown v-model="newitem.certificatetype_id" 
:options="certificatetypes" 
filter
showClear 
optionLabel="name" 
optionValue="id"
class="w-full p-inputtext-sm" />
<label for="dd-city">Döküman Türü</label>
</div>
</div>
<div class="col-2">
    
<Button label="Yeni Tür Ekle" class=" p-button-primary p-button-outlined  p-button-sm"  @click="showNewDocumentTypeDialog" ></Button>

</div>
</div>



<div class="p-float-label mb-5 mt-0">
<InputText  type="text" v-model="newitem.certification_body" class="w-full p-inputtext-sm animate_class"  />
<label for="dd-city">{{$store.state.languages.lang_phrases.sertifika_tedarikcisi}}</label>
</div>

<span class="p-float-label mb-5 mt-0" >
<Calendar v-model="newitem.valid_through"   :id="'valid_through'"  :showButtonBar="true" class="w-full p-inputtext-sm" :touchUI="true"  autocomplete="off"/>
 <label :for="'valid_through'"  >{{$store.state.languages.lang_phrases.gecerlilik_suresi}}</label>
</span>


</div>



<div class="col-12  md:col-6">

<FileUpload name="cover_image[]"  @select="onFilesAdded"  @remove="onFilesAdded"   v-model="newitem.files" :multiple="false" :showUploadButton="false" :showCancelButton="false" chooseLabel="Dosya Seçin"    :maxFileSize="10000000000" class="certificate_uploader" >
  <template #empty>
      <div class="certificate_uploader_empty">
      <span class="material-icons-outlined md-48 mr-2">backup
    </span>
      <p>Dosyaları buraya sürükleyip bırakın</p>
    </div>
  </template>
</FileUpload>

</div>

<div class="col-12">
<div class="flex align-items-center justify-content-end mt-3">

<Button :label="$store.state.languages.lang_phrases.iptal" class=" p-button-danger p-button-outlined  p-button-sm mr-2"  @click="canceladdNew"></Button>

 <Button :label="$store.state.languages.lang_phrases.yeni_ekle" class=" p-button-primary p-button-outlined  p-button-sm" :loading="$store.state.ui.submitting" @click="submitNewDocument" ></Button>
</div>


</div>    
</template>




<div class="col-12">
<DataTable 
:value="documents" 
responsiveLayout="scroll"
>
<Column field="certificatetype.name" :header="$store.state.languages.lang_phrases.sertifika_tipi"></Column>
<Column field="certification_body" :header="$store.state.languages.lang_phrases.sertifika_tedarikcisi"></Column>

<Column field="valid_through" :header="$store.state.languages.lang_phrases.gecerlilik_suresi">
    <template #body="slotProps">
        <p class="my-3">{{ $filters.momentFormat(slotProps.data.valid_through," Do-MM-YYYY ")}}</p>
    </template>
</Column>

<Column field="valid_through" :header="$store.state.languages.lang_phrases.kalan_sure">
    <template #body="slotProps">
        <template v-if="getValidDate(slotProps.data.valid_through)<0">
            <Tag 
                    class="custom-chip" 
                    :value="$store.state.languages.lang_phrases.suresi_dolmus" 
                    style="background-color:#dd4b39"
                    />
        </template>
        <template v-else>
            <p class="my-3" >{{ getValidDate(slotProps.data.valid_through)}} gün</p>
        </template>
        
    </template>
</Column>

<Column field="status" :header="$store.state.languages.lang_phrases.durum">
        <template #body="slotProps">
            <Tag 
            v-if="slotProps.data.status=='uploaded'"
            class="mr-2 mt-1 custom-chip"  
            :value="this.$store.state.languages.lang_phrases.degerlendirmede" 
            style="background-color:#3b82f6"
            />

            <Tag 
            v-if="slotProps.data.status=='rejected'"
            class="mr-2 mt-1 custom-chip"  
            :value="this.$store.state.languages.lang_phrases.gecersiz" 
            style="background-color:#a82400"
            />

            <Tag 
            v-if="slotProps.data.status=='accepted'"
            class="mr-2 mt-1 custom-chip"  
            :value="this.$store.state.languages.lang_phrases.gecerli" 
            style="background-color:#4dc247"
            />         
        </template>
    </Column>
<Column field="rejection_note" :header="$store.state.languages.lang_phrases.red_sebebi"></Column>
<Column field="filepath" :header="$store.state.languages.lang_phrases.yuklenen_dosyalar">
    <template #body="slotProps">
        <template v-if="slotProps.data.filepath">
            <a :href="apihook+slotProps.data.filepath" class="p-button p-button-primary p-button-outlined p-button-sm no_underline" target="_blank"><i class="pi pi-eye mr-2" style="font-size: 1em"></i> Görüntüle</a>

        </template>
        <template v-else>
            <Tag 
            class="custom-chip" 
            :value="$store.state.languages.lang_phrases.yuklu_dosya_yok" 
            style="background-color:#dd4b39"
            />
        </template>
        
    </template>
</Column>

<template v-if="is_admin || is_tech_auditor">
<Column field="answer" header="" style="min-width: 8rem">
    <template #body="slotProps">
        <div class="flex align-items-center justify-content-start">
        <template v-if="slotProps.data.status=='uploaded'">
            <Button :label="$store.state.languages.lang_phrases.reddet" class=" p-button-help p-button-outlined  p-button-sm  hide_on_mobile" :loading="submitting" @click="rejectDocument(slotProps.data.id)"></Button>
            <Button icon="pi pi-times" class=" p-button-help p-button-outlined  p-button-sm  show_on_mobile" :loading="submitting" @click="rejectDocument(slotProps.data.id)"></Button>


            <Button :label="$store.state.languages.lang_phrases.onayla" class=" p-button-primary p-button-outlined  p-button-sm ml-2 hide_on_mobile" :loading="submitting" @click="acceptDocument(slotProps.data.id)" ></Button>
            <Button icon="pi pi-check" class=" p-button-primary p-button-outlined  p-button-sm ml-2 show_on_mobile" :loading="submitting" @click="acceptDocument(slotProps.data.id)" ></Button>

            
        </template>

        <template v-if="slotProps.data.status=='rejected'">
            <Button :label="$store.state.languages.lang_phrases.onayla" class=" p-button-primary p-button-outlined  p-button-sm hide_on_mobile" :loading="submitting" @click="acceptDocument(slotProps.data.id)" ></Button>
            <Button icon="pi pi-check" class=" p-button-primary p-button-outlined  p-button-sm show_on_mobile" :loading="submitting" @click="acceptDocument(slotProps.data.id)" ></Button>
        </template>

        <template v-if="slotProps.data.status=='accepted'">
            <Button :label="$store.state.languages.lang_phrases.reddet" class=" p-button-help p-button-outlined  p-button-sm hide_on_mobile" :loading="submitting" @click="rejectDocument(slotProps.data.id)"></Button>
            <Button icon="pi pi-times" class=" p-button-help p-button-outlined  p-button-sm  show_on_mobile" :loading="submitting" @click="rejectDocument(slotProps.data.id)"></Button>
        </template>  
        </div>
    </template>
</Column>    
</template>

<template v-if="is_admin || is_tech_auditor || is_auditor">
<Column field="answer" header="" style="min-width: 8rem">
<template #body="slotProps">
    <template v-if="slotProps.data.status=='uploaded'">
        <Button :label="$store.state.languages.lang_phrases.sil" class=" p-button-danger p-button-outlined  p-button-sm ml-2 hide_on_mobile" :loading="submitting" @click="deleteItem('suppliercertificateupload',slotProps.data.id)"></Button>
        <Button icon="pi pi-trash" class=" p-button-danger p-button-outlined  p-button-sm ml-2 show_on_mobile" :loading="submitting" @click="deleteItem('suppliercertificateupload',slotProps.data.id)"></Button>
    </template>
    <template v-else>
            <template v-if="is_admin || is_tech_auditor">
                 <Button :label="$store.state.languages.lang_phrases.sil" class=" p-button-danger p-button-outlined  p-button-sm ml-2 hide_on_mobile" :loading="submitting" @click="deleteItem('suppliercertificateupload',slotProps.data.id)"></Button>
                <Button icon="pi pi-trash" class=" p-button-danger p-button-outlined  p-button-sm ml-2 show_on_mobile" :loading="submitting" @click="deleteItem('suppliercertificateupload',slotProps.data.id)"></Button>
            </template>            
          </template>

</template>
</Column>
</template>


</DataTable>
</div>
</div>
</div>

<Dialog v-model:visible="showdialog" modal header="Yeni Döküman Türü" :style="{ width: '50rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">

<div class="p-float-label mt-3 ">
<InputText  type="text" v-model="newdocumenttype" class="w-full p-inputtext-sm animate_class"  />
<label>{{$store.state.languages.lang_phrases.isim}}</label>
</div>


<template #footer>
 <div class="flex align-items-center justify-content-end mt-3">

<Button :label="$store.state.languages.lang_phrases.iptal" class=" p-button-danger p-button-outlined  p-button-sm mr-2"  @click="hideNewDocumentTypeDialog"></Button>

 <Button :label="$store.state.languages.lang_phrases.yeni_ekle" class=" p-button-primary p-button-outlined  p-button-sm" :loading="$store.state.ui.submitting" @click="submitNewDocumentType" ></Button>
</div>   
</template>


</Dialog>

<CertificateRejectionModal @rejected="submitRejectDocument" ref="certmodal">


</CertificateRejectionModal>


</div>
</template>
<script>
import moment from "moment";
import CertificateRejectionModal from "../suppliers/CertificateRejectionModal"
export default {

  name: 'OtherDocuments',

 data () {
    return {
    	loading:true,
    	documents:[],
        showdialog:false,
        certificatetypes:[],
        addnew:false,
        submitting:false,
        newitem:{
            files:[],
            valid_through:null,
            certification_body:"",
            certificatetype_id:null,
        },
        newdocumenttype:"",
    }
  },
  components:{CertificateRejectionModal},
  computed:{
    deletedstate()
    {
        return this.$store.state.ui.deletedstate
    },
    is_supplier()
    {
        let roles = this.$store.state.auth.userroles
        console.log(roles)
        if(roles.includes("supplier"))
        {
            return true
        }
        return false
    },
    is_planner()
    {
        let roles = this.$store.state.auth.userroles
        console.log(roles)
        if(roles.includes("planner"))
        {
            if(roles.includes("admin"))
            {
                return false
            }
            else
            {
                let viewingmode = this.$store.state.evaluation.viewingmode
                if(viewingmode=="submitting")
                {
                    return false
                }
                return true
                
            }
            
        }
        return false
    },
    is_admin()
    {
        let roles = this.$store.state.auth.userroles
        if(roles.includes("admin"))
        {
            return true
        }
        return false
    },
    is_auditor()
    {
        let roles = this.$store.state.auth.userroles
        if(roles.includes("auditor"))
        {
            return true
        }
        return false
    },
    is_tech_auditor()
    {
        let roles = this.$store.state.auth.userroles
        if(roles.includes("technical_auditor"))
        {
            return true
        }
        return false
    },
   apihook()
    {
        let api =  process.env.VUE_APP_API_HOOK
        api = api.replace("/api/","/")
        return "https://storage.googleapis.com/verifycloud/"
    },
  },
  watch:{
    deletedstate(newVal,oldVal)
    {
        if(newVal)
        {
            this.getDocuments()
        }
    }
  },
  mounted()
  {
  	this.getData()
  },
  methods:{
    showNewDocumentTypeDialog()
    {
        this.showdialog = true
    },
    hideNewDocumentTypeDialog()
    {
        this.showdialog = false
    },
    onFilesAdded(event)
    {
        this.newitem.files = []
        for(let file of event.files)
        {
            this.newitem.files.push(file)
        }
    },
    addNew()
    {
        this.addnew = true
    },
    canceladdNew()
    {
        this.newitem = {
                files:[],
                valid_through:null,
                certification_body:"",
                certificatetype_id:null,
            }
        this.addnew = false
    },
    submitNewDocument()
    {
        if(this.newitem.certification_body=="")
        {
            this.showMessage("error","Lütfen sertifika tedarikçisi ekleyin")
            return 
        }
        if(!this.newitem.valid_through)
        {
            this.showMessage("error","Lütfen geçerlilik süresini belirleyin")
            return 
        }

        if(!this.newitem.certificatetype_id)
        {
            this.showMessage("error","Lütfen sertifika türü seçin")
            return 
        }

        if(!this.newitem.files.length)
        {
            //this.showMessage("error","Lütfen belge yükleyin")
            //return 
        }

        let formdata = new FormData()

        for( var i = 0; i < this.newitem.files.length; i++ )
        {
          let file =  this.newitem.files[i];
          formdata.append('files[' + i + ']', file);
        }
        console.log(moment(this.newitem.valid_through).format("YYYY-MM-DD"))
        //return 
        formdata.append("certification_body",this.newitem.certification_body)
        formdata.append("valid_through",moment(this.newitem.valid_through).format("YYYY-MM-DD"))
        formdata.append("certificatetype_id",this.newitem.certificatetype_id)
        formdata.append("flowsupplier_id",this.$store.state.audit.audit.flowsupplier.id)
        this.generalSubmission(formdata,"audit/submitsupplier_certificate",this.getDocuments)
    },
    submitNewDocumentType()
    {
        if(this.newdocumenttype=="")
        {
            this.showMessage("error","Lütfen isim ekleyin")
            return 
        }
        let formdata = new FormData()
        formdata.append("name",this.newdocumenttype)
        this.generalSubmission(formdata,"certificatetype",this.getCertificateTypes)
    },
    getValidDate(data)
    {
        
        if(data)
        {
            let today = moment()
            let date = moment(data)
            let diff = date.diff(today, 'days')
            return diff
        }
        return 0
    },
    async getCertificateTypes()
    {
        this.showdialog = false
        this.certificatetypes = await this.generalApiGetWithoutLoader("certificatetypes")
    },
    parseAwaitingDocuments()
    {
        let count = 0
        for(let item of this.documents)
        {
            if(item.status=="uploaded")
            {
                count++
            }
        }
        this.$emit("awaitingDocsCounted",count)
    },
    async getDocuments()
    {
        this.canceladdNew()
        this.documents = await this.generalApiGetWithoutLoader("auditor_audits/get_audit_uploaded_certificates/"+this.$route.params.audit_uuid)
        this.parseAwaitingDocuments()
        this.submitting = false

    },
  	async getData()
  	{
  		this.loading = true

        await this.getCertificateTypes()
        await this.getDocuments()
  		
  		console.log(this.documents)
  		this.loading = false
  	},
    acceptDocument(id)
    {
        console.log(id)
        //return false
        this.submitting = true
        let formdata = new FormData()       
        this.generalSubmission(formdata,"audit/accept_uploaded_document/"+id,this.getDocuments)
    },
    rejectDocument(id)
    {
        this.$refs.certmodal.showModal(id)
    },
    submitRejectDocument(data)
    {
        console.log(data)        
        this.submitting = true
        let formdata = new FormData() 
        formdata.append("rejection_note",data.rejection_note) 
        this.generalSubmission(formdata,"audit/reject_uploaded_document/"+data.id,this.getDocuments)
    },
  }
}
</script>

<style lang="css" scoped>
    .certificate_uploader_empty{
    display: flex;
      width: 100%;
      height: 75px;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      border: 1px dashed rgb(180, 180, 180);
}
</style>